import React from 'react'
import BaseLanguageSelectorTab from './BaseLanguageSelectorTab'

const TestLanguageSelectorTab = (props) => {
  return (
    <BaseLanguageSelectorTab {...props} isFullWidth showAddLanguageButton />
  )
}

export default TestLanguageSelectorTab
